import { RESET_APP } from "../actionTypes/app";

const resetApp = () => (dispatch) => dispatch({ type: RESET_APP });

export { resetApp };
